// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".powered-by[data-v-5da922cc]{display:flex;flex-direction:column;justify-content:center;height:48px;width:fit-content}.powered-by_row[data-v-5da922cc]{flex-direction:row;align-items:center;justify-content:flex-start}.powered-by__powered[data-v-5da922cc]{margin-bottom:4px}.powered-by_row .powered-by__powered[data-v-5da922cc]{margin-bottom:0;margin-right:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
